module.exports = __webpack_public_path__ + "media/images/logo-white-8ee4bb41ba9d5f2a5460750d73b77969.svg";